<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container>
      <v-row>
        <v-col>
          <h3>{{ $t("messages.generateBillingCycle") }}</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p>{{ $t("messages.generateBillingCycleText") }}</p>
        </v-col>
      </v-row>

       
        <v-row>
          <v-col>
            <v-text-field v-model="date" :label="$t('basics.billingDate') + ' (' + $t('basics.optional') + ')'" variant="outlined" type="date"
              placeholder="DD.MM.YYYY"></v-text-field>
          </v-col>
        </v-row>

         <v-row>
          <v-col cols="12">
            <v-btn large block flat class="primaryButton" :loading="loading" @click="confirm()" ref="confirmButton" style="width: 100%">
              <span>{{ $t("basics.confirm") }}</span>
            </v-btn>
          </v-col>
        </v-row>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "billWarningDrawer",
  props: ["refreshDisplay"],
  emits: ["close"],

  data() {
    return {
      loading: false,
      date: undefined
    };
  },

  components: {
  },


  methods: {
    async confirm() {
      this.loading = true
      this.axios.post(this.axios.defaults.baseURL + "user/bills/post/",
        {
          date: this.date ? this.$moment(this.date).format("YYYY-MM-DD") : undefined
        }
      )
      .then(() => {
        this.$emit("close", 1)
      this.loading = false
      })
      .catch((e) => {
        console.log(e)
        window.dispatchEvent(new CustomEvent("showErrorDisplay", {detail: e}))
      this.loading = false
      })
    },
  },

  mounted() {},
};
</script>
